import { createManageRolesTable } from '../../../../components/AdminUsersPage/ManageRolesTab/createManageRolesTable.ts';
import { $$roles } from '../../../../services/RolesService/model.ts';

export const $$resellerManageRolesTable = createManageRolesTable({
  getManageableRolesFx: $$roles.getManageableRolesFx
});